import Swiper from 'swiper/bundle';

export function carousel() {
  const swiper = new Swiper('.js-index-carousel', {
    loop: true,
    speed: 500,
    effect: 'fade',
    allowTouchMove: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    },
    breakpoints: {
      768: {
        allowTouchMove: false
      }
    },
    pagination: {
      el: '.js-index-carousel_pagination',
      clickable: true,
      renderBullet: function (index, className) {
        const num = index + 1;
        return (
          `<p class="${className} p-indexKv_carousel_circle"><span class="p-indexKv_carousel_circlenum swiper-circle-num">${num}</span></p>`
        );
      }
    },
    on: {
      slideChange: function () {
        const currentSlide = document.querySelector(`[data-swiper-slide-index="${this.realIndex}"]`);
      }
    }
  });
}